import { de, el, enGB, es, fr, it, nl, pt } from 'date-fns/locale';

/**
 * Date locales and formats, without the store or i18n, so Storybook components can use them too.
 * App code goes through date_fns.js.
 */

const locales = { de, el, en: enGB, es, fr, it, nl, pt };
const DATE_FORMATS = Object.freeze({
  // The prefix 'F' refers to 'Full', meaning the value is written as a full word
  DAY_FMONTH: 'd MMMM', // 31 January
  DAY_FMONTH_YEAR: 'd MMMM yyyy', // 2nd February 2018
  DAY_MONTH_YEAR: 'dd/MM/yyyy', // 02/11/2018
  DAY_MONTH_YEAR_TIME: 'dd/MM/yyyy HH:mm', // 02/11/2018 14:37
  FDAY_DAY_FMONTH: 'EEEE d MMMM', // Monday 2 December
  FDAY_DAY_FMONTH_YEAR: 'EEEE d MMMM yyyy', // Monday 2 December 2018
  FMONTH_DAY_YEAR: 'MMMM d, yyyy', // January 31, 2018
  FMONTH_YEAR: 'MMMM yyyy', // January 2017
  FULL_DATE: 'do MMMM yyyy, HH:mm', // 2nd January 2018, 24:12
  TIME: 'HH:mm', // '23:12'
  LOCALE_DATE_TIME: 'Pp', // locale-aware date + time
  YEAR_MONTH_DAY: 'yyyy-MM-dd', // 2018-11-01
  YEAR_MONTH_DAY_TIME: 'd MMMM yyyy, HH:mm', // 2018-11-01, 24:12
});

// German writes the day of the month as an ordinal, so `d MMMM` has to render 31. Januar.
// Keyed on the English format string so callers keep passing DATE_FORMATS unchanged.
const FORMAT_OVERRIDES = Object.freeze({
  de: {
    'd MMMM': 'd. MMMM',
    'd MMMM yyyy': 'd. MMMM yyyy',
    'EEEE d MMMM': 'EEEE, d. MMMM',
    'EEEE d MMMM yyyy': 'EEEE, d. MMMM yyyy',
    'MMMM d, yyyy': 'd. MMMM yyyy',
    'do MMMM yyyy, HH:mm': 'd. MMMM yyyy, HH:mm',
    'd MMMM yyyy, HH:mm': 'd. MMMM yyyy, HH:mm',
  },
});

function formatStringForLanguage(format_string, language) {
  return (FORMAT_OVERRIDES[language] || {})[format_string] || format_string;
}

export { DATE_FORMATS, formatStringForLanguage, locales };
